import React, { Component } from 'react';
import jQuery from 'jquery';

class BeWise_CourseSideBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user_name: '',
            logged: localStorage.getItem("authentication"),
            auth_data: JSON.parse(localStorage.getItem("user_data"))
        };

    }

    componentDidMount() {

        this.setState({user_name:this.state.auth_data.user_name, role:this.state.auth_data.role});

    }

    render() {

         
        return (

        <React.Fragment>
         
        <nav class="sidebar sidebar-offcanvas" id="sidebar">
        <ul class="nav">
          <li class="nav-item">
            <div class="d-flex sidebar-profile">
              <div class="sidebar-profile-image">
                <img src="/images/faces/face29.png" alt="image" />
                <span class="sidebar-status-indicator"></span>
              </div>
              <div class="sidebar-profile-name">
                <p class="sidebar-designation">
                  welcome 
                  <span class="loggeduserdisplay">{this.state.user_name}</span>
                </p>
              </div>
            </div>
         
          </li>


            <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#dashboard" aria-expanded="false" aria-controls="form-elements">
                <i class="typcn typcn-film menu-icon"></i>
                <span class="menu-title">Dashboard</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="dashboard">
                <ul class="nav flex-column sub-menu">
                <li class="nav-item"><a class="nav-link" id="dashboard" href="/courses/dashboard">Dashboard</a></li>
                <li class="nav-item"><a class="nav-link" id="addcourse" href="/courses/addcourse">Add a course</a></li>
                <li class="nav-item"><a class="nav-link" id="listcourses" href="/courses/listcourses">List courses</a></li>
                
                </ul>
            </div>
            </li>
       </ul>
        
        </nav>
            </React.Fragment>

        )
    }
}


export default BeWise_CourseSideBar;


// WEBPACK FOOTER //
// ./src/components/bewise/coursesideBar.jsx